module.exports = __webpack_public_path__ + "media/images/default/pages/about/clinic-new-5-0080316b29c6aa89652d455ad387635e.jpeg";